import { Component, Watch } from 'vue-property-decorator';
import Peer from 'simple-peer';
import EditorBase from './EditorBase';
import { ESocketEvent } from '@/helpers/socket';
import { EAnalyticsEvent } from '@/helpers/analytic';


@Component({})
export default class PeerConnectionManager extends EditorBase {
  peerConnections = {};
  getIceConfigInterval: number = null;

  async mounted() {
    await this.preparePeerConnection();
  }

  destroyed() {
    this.deactivateWebcam();
    clearInterval(this.getIceConfigInterval);
    this.getIceConfigInterval = null;
  }

  async loadIceConfig() {
    await this.getIceServerConfig(this.currentUser.identifier);

    if (this.iceConfig && !this.getIceConfigInterval) {
      const intervalTime: any = new Date(this.iceConfig.expires_at).getTime() - new Date().getTime() - 100;
      this.getIceConfigInterval = setInterval(this.loadIceConfig, intervalTime);
    }
  }

  async preparePeerConnection() {
    this.loadIceConfig();

    this.addSocketEventListener(ESocketEvent.peerConnectionRequest, this.onPeerConnectionRequest);
    this.addSocketEventListener(ESocketEvent.peerConnectionSignal, this.onPeerConnectionSignal);
    this.addSocketEventListener(ESocketEvent.webcamPeerDisconnect, this.onWebcamPeerDisconnect);
  }

  deactivateWebcam() {
    this.sendSocketEvent(ESocketEvent.webcamBroadcasterDisconnect);
    this.destroyPeerConnections();
    this.webcamStream = null;
    this.$socket.client.off(ESocketEvent.peerConnectionRequest, this.onPeerConnectionRequest);
    this.$socket.client.off(ESocketEvent.peerConnectionSignal, this.onPeerConnectionSignal);
    this.$socket.client.off(ESocketEvent.webcamPeerDisconnect, this.onWebcamPeerDisconnect);
  }

  onPeerConnectionRequest(data) {
    const { from } = data;

    const peerConnection = new Peer({
      initiator: false,
      config: { iceServers: [this.iceConfig] },
      stream: this.webcamStream,
    });

    peerConnection.on('signal', (signal) => {
      this.sendSocketEvent(ESocketEvent.peerConnectionSignal, { signal, to: from });
    });

    peerConnection.on('error', (err) => {
      this.$sla.sendEvent(EAnalyticsEvent.peerConnectionError, { data: err });
    });

    this.peerConnections[from] = peerConnection;

    this.sendSocketEvent(ESocketEvent.peerConnectionAccepted, { to: from });
  }

  onPeerConnectionSignal(data) {
    const { from, signal } = data;
    this.peerConnections[from].signal(signal);
  }

  onWebcamPeerDisconnect(socketId) {
    if (!this.peerConnections[socketId]) return;
    this.peerConnections[socketId].destroy();
    delete this.peerConnections[socketId];
  }

  destroyPeerConnections() {
    Object.keys(this.peerConnections).forEach((peerConnectionId) => {
      this.peerConnections[peerConnectionId].destroy();
      delete this.peerConnections[peerConnectionId];
    });
  }

  @Watch('webcamStream')
  webcamStreamOnChange() {
    if (!this.webcamStream) return;

    Object.keys(this.peerConnections).forEach((peerConnectionId) => {
      if (this.peerConnections[peerConnectionId]?._pc) this.peerConnections[peerConnectionId].addStream(this.webcamStream);
    });
  }
}
